import { Controller } from '@hotwired/stimulus'

// hidden input 自身に付与され、GA4 の session_id を value に載せる。
// GA未初期化/ブロック/measurement id 未設定時は空のまま（サーバーでNULL保存）。
export default class extends Controller {
  connect () {
    const measurementId = document.querySelector('meta[name="ga-measurement-id"]')?.content
    if (!measurementId || typeof window.gtag !== 'function') return

    try {
      window.gtag('get', measurementId, 'session_id', (sessionId) => {
        if (sessionId) this.element.value = sessionId
      })
    } catch (e) {
      // 取得失敗は非クリティカル（NULL保存で継続）
      if (window.Sentry) window.Sentry.captureException(e)
    }
  }
}
